__turbopack_context__.v({
  "articlesSection": "TeaserAlways-module-scss-module__VQnWlG__articlesSection",
  "buttonWrapper": "TeaserAlways-module-scss-module__VQnWlG__buttonWrapper",
  "copy": "TeaserAlways-module-scss-module__VQnWlG__copy",
  "desktopGrid": "TeaserAlways-module-scss-module__VQnWlG__desktopGrid",
  "header": "TeaserAlways-module-scss-module__VQnWlG__header",
  "headerInner": "TeaserAlways-module-scss-module__VQnWlG__headerInner",
  "mobileSlide": "TeaserAlways-module-scss-module__VQnWlG__mobileSlide",
  "mobileSlider": "TeaserAlways-module-scss-module__VQnWlG__mobileSlider",
  "sidebar": "TeaserAlways-module-scss-module__VQnWlG__sidebar",
  "swiperFull": "TeaserAlways-module-scss-module__VQnWlG__swiperFull",
  "title": "TeaserAlways-module-scss-module__VQnWlG__title",
});
